import { css } from 'styled-components';
export const modalCloseStyle = _ref => {
  let {
    theme,
    $variant
  } = _ref;
  return css(["padding:1.25rem;position:absolute;color:", ";top:0;right:0;cursor:pointer;border:0;background:none;z-index:5;outline:0;", ""], theme.palettes.neutrals.medium, $variant === 'OVERLAY' ? `
      padding: 0;
      background-color: ${theme.palettes.brand.primary};
      color: ${theme.palettes.neutrals.lightest};
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
      border-radius: 50%;
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 1.25rem 1.25rem 0 0;
    ` : '');
};
//# sourceMappingURL=ModalClose.style.js.map